<script setup>
    const props = defineProps({
        email: String
    });

</script>

<template>
    <div class="invitation__data_email">
        <div class="form-description">
            <span class="invitation-description-email">
                {{  email}}
            </span>
        </div>
        
    </div>
</template>
<style lang="scss">
.invitation__data_email {
    display: flex;
    gap: 1em;
    padding-bottom: 5px;
}

@media (max-width: 576px) {
    .invitation__data_email{
        flex-direction: column;
        gap: 0em;
        padding-bottom: 5px;
    }
}
</style>